import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PurchaseBillService } from '../../../../Services/PurchaseBill/purchase-bill.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { AccountService } from '../../../../Services/Accounts/account.service';

@Component({
  selector: 'app-purchase-bill',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './purchase-bill.component.html',
  styleUrl: './purchase-bill.component.css'
})
export class PurchaseBillComponent {
  // Form Model matching your Postman/Backend requirements
  purchaseData = {
    date: new Date().toISOString().split('T')[0],
    amount: null as number | null,
    expense_account_id: null as number | null,
  };

  expenseAccounts: any[] = [];
  selectedFile: File | null = null;
  fileName: string = '';
  isSaving: boolean = false;

  constructor(
    private purchaseBillService: PurchaseBillService,
    private accountService: AccountService,
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService
  ) { }

  ngOnInit() {
    this.loadExpenseAccounts();
  }

  loadExpenseAccounts() {
    // Current firm
    const currentFirm = this.firmSelectionService.getselectedFirmName();
    if (!currentFirm) return;

    this.accountService.getAccounts({
      firm_id: currentFirm.id,
      primary: 'Expense'
    }).subscribe({
      next: (res: any) => {
        this.expenseAccounts = res.data || [];
        // Optional: default to "Purchase Account" if found
        const purchaseAcc = this.expenseAccounts.find(a => a.acc_user_acc === 'Purchase Account');
        if (purchaseAcc) {
          this.purchaseData.expense_account_id = purchaseAcc.acc_id;
        }
      },
      error: (err) => console.error('Error loading expense accounts', err)
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.fileName = file.name;
    }
  }

  submitPurchase() {
    // Validation
    if (!this.purchaseData.amount || !this.purchaseData.date || !this.selectedFile || !this.purchaseData.expense_account_id) {
      alert('Please fill all fields, select an account, and attach a document.');
      return;
    }

    this.isSaving = true;

    // Use FormData for File Uploads
    const formData = new FormData();
    formData.append('bill_date', this.purchaseData.date);
    formData.append('amount', this.purchaseData.amount.toString());
    formData.append('expense_account_id', this.purchaseData.expense_account_id.toString());
    formData.append('document', this.selectedFile);

    // Add firm_id from session
    const currentFirm = this.firmSelectionService.getselectedFirmName();
    if (currentFirm) {
      formData.append('firm_id', currentFirm.id.toString());
    }

    this.purchaseBillService.cretePurchaseBills(formData).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        if (res.success) {
          this.notificationService.showSuccess("Purchase bill uploaded successfully", "success");
          this.resetForm();
        }
      },
      error: (err: any) => {
        this.isSaving = false;
        console.error(err);
        alert('Error uploading bill. Please try again.');
      }
    });
  }

  resetForm() {
    this.purchaseData = {
      date: new Date().toISOString().split('T')[0],
      amount: null,
      expense_account_id: this.purchaseData.expense_account_id // Keep the last selected account or Purchase as default
    };
    this.selectedFile = null;
    this.fileName = '';
  }
}